import { serviceReduxConstants } from '@/constants';
import { Service } from '@/types/services';

export type ServicesState = {
  ids: Array<number>;
  all: {
    [id: number]: Service;
  };
};

export function services(
  state: ServicesState = { ids: [], all: {} },
  action: { type: string; payload?: ServicesState; payloadService?: Service },
): ServicesState {
  switch (action.type) {
    case serviceReduxConstants.SET_SERVICES:
      return {
        ids: [...state.ids, ...action.payload.ids],
        all: {
          ...state.all,
          ...action.payload.all,
        },
      };

    default:
      return state;
  }
}
